import { render, staticRenderFns } from "./ProcessCard.vue?vue&type=template&id=534751fe&scoped=true&lang=true&"
import script from "./ProcessCard.vue?vue&type=script&lang=js&"
export * from "./ProcessCard.vue?vue&type=script&lang=js&"
import style0 from "./ProcessCard.vue?vue&type=style&index=0&id=534751fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534751fe",
  null
  
)

export default component.exports